module.exports = __webpack_public_path__ + "static/beaker-favicon-6a12cebf298769fe05b65b462b698dc8.png";